import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HandlingEquipmentSettings } from "./NumberingConfigurationPage";
import { PageHeader } from "./PageHeader";

export function HandlingEquipmentMasterDataPage({ onBack }: { onBack: () => void }) {
  const { t } = useTranslation();
  return (
    <Stack spacing={1.5} sx={{ height: { md: "100%" }, minHeight: 0 }}>
      <PageHeader title={t("handlingEquipment.module")} compact onBack={onBack} />
      <HandlingEquipmentSettings />
    </Stack>
  );
}
